// export * from './translate.service';
// export * from './translations';
// export * from './translate.pipe';

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {TranslatePipe} from './translate.pipe';
import {TRANSLATION_PROVIDERS} from './translations';
import {TranslateService} from './translate.service';

@NgModule({
    imports: [
    ],
    declarations: [
    TranslatePipe
    ],
    providers: [
        TRANSLATION_PROVIDERS,
        TranslateService
    ],
    exports: [TranslatePipe]
})

export class TranslateModule { }